import {
  BlogsPostCardProps,
  BlogsPostCardTemplateProps,
  BlogsPostCardDefaultTemplate,
} from '../../..';
import { useBlogsPostCardEffect } from '../effect';

export const BlogsPostCardSegment = (props: BlogsPostCardProps) => {
  const [handlers, state] = useBlogsPostCardEffect(props);

  const templateProps: BlogsPostCardTemplateProps = {
    ...props,
    ...handlers,
    ...state,
  };

  let template;
  switch (props.template) {
    case 'blogsPostCardDefault':
    default:
      template = BlogsPostCardDefaultTemplate(templateProps);
      break;
  }

  return template;
};
